<template>
  <div class="portal">
    <el-image
      class="banner pc"
      fit="cover"
      :src="require('@/assets/images/whkcsz/banner.jpg')"
    ></el-image>
    <el-image
      class="banner mobile"
      fit="cover"
      :src="require('@/assets/images/whkcsz/mobile_banner.jpg')"
    ></el-image>
    <div class="main">
      <section class="section demonstration-course">
        <div class="container">
          <div class="section-title">
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_left.png')"
            ></el-image>
            <span class="title">示范课程</span>
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_right.png')"
            ></el-image>
          </div>
          <div class="content" v-if="courseList.length > 0">
            <el-row :gutter="24">
              <el-col
                :sm="6"
                :xs="12"
                v-for="(item, index) in courseList"
                :key="'course_' + index"
              >
                <div
                  class="item"
                  @click="goDetail('/whkcsz/courseDetail/' + item.courseId, 1)"
                >
                  <el-image
                    class="cover"
                    fit="contain"
                    :src="item.coverUrl | setCourseCover"
                  >
                    <div slot="error" class="img-error">
                      <img
                        :src="require('@/assets/images/whkcsz/default_img.png')"
                      />
                    </div>
                  </el-image>
                  <div class="info">
                    <p class="title">
                      <i class="iconfont iconkecheng pc"></i>
                      <span>{{ item.courseName }}</span>
                    </p>
                    <span class="num"
                      >访问量：{{ item.viewCount | setViewCount }}</span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :sm="6" :xs="12">
                <div class="item go-more">
                  <el-link href="#/whkcsz/courses" :underline="false"
                    >查看更多<i class="iconfont icongengduo2"></i
                  ></el-link>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </section>
      <section class="section lastest-resource">
        <div class="container">
          <div class="section-title">
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_left.png')"
            ></el-image>
            <span class="title">最新资源</span>
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_right.png')"
            ></el-image>
          </div>
          <div class="content">
            <el-row :gutter="24">
              <el-col
                :sm="6"
                :xs="12"
                v-for="(item, index) in resourceList"
                :key="'course_' + index"
              >
                <div
                  class="item"
                  @click="
                    goDetail(
                      'https://rm.ulearning.cn/#/resourceDetail/' + item.id,
                      2
                    )
                  "
                >
                  <div class="cover">
                    <el-image fit="fill" :src="item.thumbnail">
                      <div slot="error" class="image-error">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <span class="title">{{ item.name }}</span>
                  <span class="date">{{ item.updateTime | timeFormat }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-button
            class="more"
            @click="goDetail('https://rm.ulearning.cn/#/portal/11', 2)"
          >
            <span class="pc">查看更多</span>
            <span class="mobile">更多</span>
          </el-button>
        </div>
      </section>
      <section class="section news-list">
        <div class="container">
          <div class="section-title">
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_left.png')"
            ></el-image>
            <span class="title">新闻资讯</span>
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_right.png')"
            ></el-image>
          </div>
          <div class="content">
            <el-row :gutter="24">
              <el-col
                class="item-wrapper"
                :sm="12"
                :xs="24"
                v-for="(item, index) in newsList"
                :key="'news_' + index"
              >
                <div
                  class="item"
                  @click="goDetail('/whkcsz/news/' + item.newsId, 1)"
                >
                  <el-row>
                    <el-col class="info" :md="19" :sm="18" :xs="24">
                      <i class="iconfont iconxinwen"></i>
                      <span class="title">{{ item.newsTitle }}</span>
                    </el-col>
                    <el-col class="time" :md="5" :sm="6" :xs="24">
                      <span class="mobile">发布时间：</span
                      >{{ item.createDate | timeFormat }}
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-button class="more" @click="goDetail('/whkcsz/news', 1)">
            <span class="pc">查看更多</span>
            <span class="mobile">更多</span>
          </el-button>
        </div>
      </section>
      <section class="section college-list">
        <div class="container">
          <div class="section-title">
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_left.png')"
            ></el-image>
            <span class="title">合作院校</span>
            <el-image
              fit="contain"
              :src="require('@/assets/images/whkcsz/title_right.png')"
            ></el-image>
          </div>
          <div class="content">
            <el-row :gutter="24">
              <el-col
                :sm="6"
                :xs="12"
                v-for="(item, index) in collegeList"
                :key="'college_' + index"
              >
                <div
                  class="item"
                  :class="{ hasLink: item.link }"
                  @click="goDetail(item.link, 2)"
                  v-if="index < 16"
                >
                  <el-image
                    class="cover"
                    fit="contain"
                    :src="require('@/assets/images/whkcsz/' + item.pic)"
                  ></el-image>
                  <div class="btn-wrapper">
                    <el-button class="go-detail">查看详情</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-button class="more" @click="goDetail('/whkcsz/colleges', 1)">
            <span class="pc">查看更多</span>
            <span class="mobile">更多</span>
          </el-button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import config from "../config";
import {
  getCourseList,
  getResourceList,
  getNewsList,
  getSubjectList,
} from "@/api/api.js";
import util from "@/libs/util.js";
export default {
  name: "portal",
  data() {
    return {
      courseList: [],
      resourceList: [],
      newsList: [],
      collegeList: config.colleges,
    };
  },
  filters: {
    setCourseCover(src) {
      return util.setCourseCover(src);
    },
    setViewCount(count) {
      return util.setViewCount(count);
    },
    timeFormat(time) {
      return util.timeFormat(time, "yyyy-MM-dd");
    },
  },
  created() {
    getSubjectList().then((res) => {
      if (res.courseEducationOneId && res.courseEducationTwoId) {
        getCourseList({
          classifyId: res.courseEducationTwoId,
          parentId: res.courseEducationOneId,
          key: "",
          ps: 7,
          pn: 1,
        }).then((res) => {
          if (res && res.result && res.result.list) {
            this.courseList = res.result.list;
          }
        });
      }
    });
    // 线上id是11
    getResourceList(11).then((res) => {
      if (res) {
        let docList = res.docResources ? res.docResources : [];
        let videoList = res.videoResources ? res.videoResources : [];
        this.resourceList = videoList.concat(docList);
      }
    });
    getNewsList({
      category: 7,
      ps: 8,
      pn: 1,
    }).then((res) => {
      if (res && res.newsList) {
        this.newsList = res.newsList;
      }
    });
    this.$emit("getShareParams", {
      shareSummary: "https://kcsz.ulearning.cn/",
    });
  },
  methods: {
    goDetail(link, type) {
      if (!link) {
        return;
      }
      if (type === 2) {
        window.open(link, "_blank");
      } else {
        this.$router.push({
          path: link,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../variables.scss";
.portal {
  .banner {
    height: 360px;
    @media (max-width: 767px) {
      height: auto;
    }
  }
  .banner,
  .cover {
    display: block;
  }
  .main .section {
    padding-bottom: 50px;
    text-align: center;
    color: #444444;
    @media (max-width: 767px) {
      padding-bottom: 30px;
    }
    .section-title {
      padding: 50px 0 30px;
      text-align: center;
      font-size: 0;
      .title {
        display: inline-block;
        vertical-align: middle;
        margin: 0 20px;
        font-size: 28px;
        color: $primary-color;
        line-height: 28px;
        font-weight: bold;
      }
      .el-image {
        max-width: 69px;
        height: 28px;
        vertical-align: middle;
      }
      @media (max-width: 767px) {
        padding: 30px 0 20px;
        .title {
          margin: 0 5px;
          font-size: 20px;
          line-height: 30px;
        }
        .el-image {
          max-width: 76px;
          height: 30px;
          vertical-align: middle;
        }
      }
    }
    .content {
      text-align: left;
    }
    .more {
      width: 140px;
      font-size: 16px;
      color: $primary-color;
      background-color: #ffffff;
      border: 1px solid $primary-color;
      border-radius: 4px;
      &:hover {
        background-color: $primary-color;
        color: #ffffff;
      }
      @media (max-width: 767px) {
        width: 88px;
        padding: 9px 20px;
        font-size: 12px;
      }
    }
    &.demonstration-course {
      padding-bottom: 26px;
      @media (max-width: 767px) {
        padding-bottom: 6px;
        .section-title {
          padding-top: 24px;
        }
      }
      .content {
        .item {
          position: relative;
          margin-bottom: 24px;
          padding-top: 56.25%;
          background-color: #f5f5f5;
          cursor: pointer;
          transition: 0.3s;
          .cover {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 81px;
          }
          .info {
            padding: 10px 10px 16px;
            .title {
              margin: 0 0 10px;
              font-size: 16px;
              font-weight: bold;
              line-height: 24px;
              @include ellipsis-one(100%);
              .iconfont {
                margin-right: 10px;
                font-weight: normal;
                color: #f4a747;
              }
            }
            .num {
              font-size: 14px;
              color: #888888;
              line-height: 20px;
            }
          }
          &:hover {
            -webkit-transform: scale(1.04);
            -moz-transform: scale(1.04);
            -ms-transform: scale(1.04);
            transform: scale(1.04);
            box-shadow: 0 2px 15px 0 rgba(215, 215, 215, 0.8);
            .info .title {
              color: $primary-color;
            }
            @media (max-width: 767px) {
              transform: none;
              box-shadow: none;
            }
          }
          &.go-more {
            position: relative;
            padding-top: 56.25%;
            padding-bottom: 82px;
            background-color: #f5f5f5;
            .el-link {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              font-size: 18px;
              font-weight: bold;
              line-height: 28px;
              color: $primary-color;
              .iconfont {
                margin-left: 8px;
                font-weight: normal;
                font-size: 18px;
              }
              &:hover {
                background-color: $primary-color;
                color: #ffffff;
              }
            }
          }
        }
        @media (max-width: 767px) {
          .el-row {
            margin-left: -7.5px !important;
            margin-right: -7.5px !important;
            .el-col {
              padding-left: 7.5px !important;
              padding-right: 7.5px !important;
              .item {
                margin-bottom: 20px;
                background-color: #ffffff;
                .cover {
                  bottom: 59px;
                }
                .info {
                  padding: 10px 0 0;
                  .title {
                    margin: 0 0 8px;
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 20px;
                  }
                  .num {
                    font-size: 12px;
                    color: #969696;
                    line-height: 21px;
                  }
                }
                &.go-more {
                  padding-bottom: 60px;
                  background-color: #f5f5f5;
                  .el-link {
                    font-size: 16px;
                    line-height: 28px;
                    .iconfont {
                      font-size: 14px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    &.lastest-resource {
      background-color: rgba(243, 243, 249, 0.5);
      background-image: url("~@/assets/images/whkcsz/resource_bg.jpg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .content {
        margin-bottom: 30px;
        padding: 24px 20px 0;
        background-color: #ffffff;
        .item {
          margin-bottom: 24px;
          cursor: pointer;
          transition: 0.3s;
          .cover {
            position: relative;
            padding-top: 56.25%;
            overflow: hidden;
            .el-image {
              position: absolute;
              left: 0;
              top: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              background-color: #f5f5f5;
              color: #969696;
              font-size: 20px;
              .image-error {
                text-align: center;
              }
            }
          }
          .title {
            display: block;
            margin: 14px 0 6px;
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;
            @include ellipsis-one(100%);
          }
          .date {
            font-size: 14px;
            color: #969696;
            line-height: 20px;
          }
          &:hover {
            -webkit-transform: scale(1.04);
            -moz-transform: scale(1.04);
            -ms-transform: scale(1.04);
            transform: scale(1.04);
            .cover {
              box-shadow: 0 2px 15px 0 rgba(215, 215, 215, 0.8);
            }
            .title {
              color: $primary-color;
            }
            @media (max-width: 767px) {
              transform: none;
              .cover {
                box-shadow: none;
              }
            }
          }
        }
      }
      @media (max-width: 767px) {
        background: none;
        background-color: #f8f9fc;
        .content {
          margin-bottom: 0;
          padding: 0;
          background-color: #f8f9fc;
          .el-row {
            margin-left: -7.5px !important;
            margin-right: -7.5px !important;
            .el-col {
              padding-left: 7.5px !important;
              padding-right: 7.5px !important;
              .item {
                margin-bottom: 20px;
                .title {
                  margin: 10px 0 8px;
                  font-size: 14px;
                  line-height: 21px;
                  font-weight: normal;
                }
                .date {
                  font-size: 12px;
                  color: #969696;
                  line-height: 18px;
                }
              }
            }
          }
        }
      }
    }
    &.news-list {
      .content {
        margin: 4px 0 0;
        .item-wrapper {
          .item {
            margin-bottom: 24px;
            padding-bottom: 24px;
            border-bottom: 1px dashed #dddddd;
            cursor: pointer;
            .info {
              font-size: 14px;
              font-weight: bold;
              line-height: 20px;
              @include ellipsis-one(100%);
              .iconfont {
                margin-right: 10px;
                font-size: 16px;
                font-weight: normal;
                color: #f4a747;
              }
            }
            .time {
              font-size: 14px;
              text-align: right;
              line-height: 20px;
            }
            &:hover {
              color: $primary-color;
            }
          }
          &:last-child {
            .item {
              margin-bottom: 10px;
              border-bottom: none;
            }
          }
          &:nth-last-child(2) {
            &:nth-child(odd) {
              .item {
                margin-bottom: 10px;
                border-bottom: none;
              }
            }
          }
        }
        @media (max-width: 767px) {
          margin: 0;
          .item-wrapper {
            .item {
              margin-bottom: 10px;
              padding-bottom: 10px;
              .info {
                margin-bottom: 8px;
                font-weight: normal;
                .iconfont {
                  font-size: 14px;
                }
              }
              .time {
                padding-left: 24px;
                font-size: 12px;
                text-align: left;
                line-height: 18px;
                color: #888888;
                span.mobile {
                  display: inline !important;
                }
              }
            }
            &:nth-last-child(2) {
              &:nth-child(odd) {
                .item {
                  border-bottom: 1px dashed #dddddd;
                }
              }
            }
          }
        }
      }
    }
    &.college-list {
      background-color: #f8f9fc;
      background-image: url("~@/assets/images/whkcsz/college_bg.jpg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .content {
        margin-bottom: 6px;
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin-bottom: 24px;
          height: 76px;
          padding: 0 10px;
          text-align: center;
          background-color: #ffffff;
          /deep/.el-image .el-image__inner {
            width: auto;
            max-width: 100%;
            max-height: 40px;
          }
          .btn-wrapper {
            display: none;
            position: absolute;
            width: 100%;
            height: 100%;
            line-height: 76px;
            background-color: rgba(205, 34, 36, 0.9);
            .go-detail {
              padding: 10px 20px;
              font-size: 12px;
              color: $primary-color;
              border: unset;
              &:hover {
                background-color: #ffffff;
              }
            }
          }
          &.hasLink {
            cursor: pointer;
            &:hover {
              .btn-wrapper {
                display: inline-block;
              }
            }
          }
        }
      }
      @media (max-width: 767px) {
        padding-bottom: 40px;
        background: none;
        background-color: #f8f9fc;
        .content {
          margin-bottom: 5px;
          .el-row {
            margin-left: -7.5px !important;
            margin-right: -7.5px !important;
            .el-col {
              padding-left: 7.5px !important;
              padding-right: 7.5px !important;
              .item {
                margin-bottom: 15px;
                height: 45px;
                padding: 0 5px;
                .el-image {
                  height: 24px;
                }
                &.hasLink {
                  &:hover {
                    .btn-wrapper {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
